import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Alert } from 'selenium-webdriver';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.css']
})
export class TransactionDetailsComponent implements OnInit {

  GetApplicantTransactionDetails: any;
  DebitTotal: number;
  CreditTotal: number;
  ClosingBalance: number;
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalItems: number;
  data: any;
  userName: any;
  t: any = [];
  j: any = [];
  numbers: any;
  Totalpropertycost: number;
  PropertyNoAllotted: null;
  balanceamount: number;
  initialdepositamount: any;
  totalamaounttobepaid: number;
  selectedApplicationNumber: any;
  isPrintMode: boolean = false;

  constructor(private userService: UserService, private errorHandler: ErrorHandler) {

  }

  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.GetByIdTransactionDetailsApplicant(this.userName);
    
    // this.ApplicantTransactionDetails(this.itemsPerPage, 1)
  }

  // pageChanged(pageNumber: number) {
  //   this.ApplicantTransactionDetails(this.itemsPerPage, pageNumber);
  // }

  // itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
  //   this.ApplicantTransactionDetails(this.itemsPerPage, pageNo);
  // }


  GetByIdTransactionDetailsApplicant(userName) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetTransactionDetailsforApplicant(userName);
    this.data.subscribe(
      (response: any) => {
        this.j = response;
        console.log(' data1 :' + JSON.stringify(this.t.APP_Id));
        this.GetByIdTransation(this.t.APP_Id);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

  GetTransaction(APP_Id) {
    // //debugger;
    this.data = this.userService.GetTransactionDetailsforApplicant(APP_Id);
    this.data.subscribe(
      (response: any) => {
        this.numbers = response;
      })
    this.GetByIdTransation(APP_Id);

  }
  // ApplicantTransactionDetails(App_Id) {

  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.userService.GetApplicantTransactionDetails(App_Id)
  //     .subscribe(
  //       (data: any) => {
  //         this.GetApplicantTransactionDetails = data.TransactionModels;
  //         this.totalItems = data.TotalItemsCount;
  //         this.itemsPerPage = itemsPerPage;
  //         this.currentPage = pageNo;
  //         this.GetDebitTotal();
  //         this.GetCreditTotal();
  //         this.GetClosingBalance();
  //         document.getElementById('loader-spinner').style.display = "none";
  //       }, (error: any) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         this.errorHandler.HandlerError(error);
  //       });
  // }
  GetByIdTransation(App_Id) {
    

    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetApplicantTransactionDetails(App_Id);
    this.data.subscribe(
      (response: any) => {
        this.t = response.TransactionModels;
       
           const selected = this.j.find(x => x.APP_Id == App_Id);
          this.selectedApplicationNumber = selected ? selected.APP_No : '';
          console.log('selected',this.selectedApplicationNumber);


        if(this.t.length == 0)
          {
            swal('Warning!', 'Transaction details not found', 'warning');
            document.getElementById('loader-spinner').style.display = "none";
            this.DebitTotal = 0;
            this.CreditTotal = 0;
            this.ClosingBalance = 0;
            this.Totalpropertycost = 0;
            this.PropertyNoAllotted = null;
            this.balanceamount = 0;
            return;
          }
          this.Totalpropertycost = this.t[0].PR_Prop_FinalCost;
          this.PropertyNoAllotted= this.t[0].PR_Property_No;
          this.t.forEach((item: any) => {
          if (item.Amount_type === 'Reg_Fee') {
              item.Amount_type = 'Registration Fee';
          } else if (item.Amount_type === 'App_Fee') {
              item.Amount_type = 'Application Fee';
          } else if (item.Amount_type === 'Initial_Deposit') {
              item.Amount_type = 'Initial Deposit';
              this.initialdepositamount = item.Debit
          }
          });
          console.log(this.GetApplicantTransactionDetails);
          
          //this.totalItems = data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
          this.GetDebitTotal();
          this.GetCreditTotal();
          this.GetClosingBalance();
          this.Getamounttobepaid();
          //this.getpropertydetailsofapplicant(APP_No);
          if(this.Totalpropertycost != null){
          this.getbalanceamount();
          }
          else{
            this.Totalpropertycost = 0;
            this.balanceamount = 0;
          }


        // this.GetDebitTotal();
        // this.GetCreditTotal();
        // this.GetClosingBalance();
        // this.ChangeOfDivision(response.EMP_DIVISION_ID)     
        // this.ChangeOfEmployee(response.EMP_ID);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetDebitTotal() {
    
    let totals = 0;
    for (let i = 0; i < this.t.length; i++) {
      totals += this.t[i].Debit;
    }
    this.DebitTotal = totals;
  }

  GetCreditTotal() {
    let totals = 0;
    for (let i = 0; i < this.t.length; i++) {
      totals += this.t[i].Credit;
    }
    this.CreditTotal = totals;
  }

  Getamounttobepaid() {
 
  let totals1 = 0;

  for (let i = 0; i < this.t.length; i++) {
    const amtType = this.t[i].Amount_type;
    const debit = this.t[i].Debit;

    if (amtType === 'Initial Deposit' || amtType.startsWith('Installment')) {
      totals1 += Number(debit); // Make sure 'Debit' is a number
    }
  }

  this.totalamaounttobepaid = totals1;
}

 getbalanceamount(){
 
  this.balanceamount = this.Totalpropertycost-this.totalamaounttobepaid;
  console.log(this.balanceamount);
 }




  GetClosingBalance() {
    this.ClosingBalance = this.DebitTotal - this.CreditTotal;
  }

  // print(): void {
  //   debugger;
  // this.isPrintMode = true;
  //   const printContents = document.getElementById('print-section').innerHTML;
  //   const stylesHtml = this.getTagsHtml('style');
  //   const linksHtml = this.getTagsHtml('link');
  //   const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  //   popupWin.document.open();
  //   popupWin.document.write(`
  //   <html>
  //       <head>
  //           <title>Transaction Details</title>
  //           ${linksHtml}
  //           ${stylesHtml}
  //       </head>
  //       <body onload="window.print(); window.close()">
  //           ${printContents}
  //       </body>
  //   </html>
  //   `
  //   );
  //   popupWin.document.close();
  //    this.isPrintMode = false;
  // }

// print(): void {
//   this.isPrintMode = true;

//   setTimeout(() => {
//     const printContents = document.getElementById('print-section').innerHTML;
//     const stylesHtml = this.getTagsHtml('style');
//     const linksHtml = this.getTagsHtml('link');
//     const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

//     popupWin.document.open();
//     popupWin.document.write(`
//       <html>
//           <head>
//               <title>Transaction Details</title>
//               ${linksHtml}
//               ${stylesHtml}
//           </head>
//           <body onload="window.print(); window.close()">
//               ${printContents}
//           </body>
//       </html>
//     `);
//     popupWin.document.close();

//     // Restore view mode
//     this.isPrintMode = false;
//   }, 0);
// }



print(): void {
  this.isPrintMode = true;

  setTimeout(() => {
    const printContents = document.getElementById('print-section').innerHTML;
    const stylesHtml = this.getTagsHtml('style');
    const linksHtml = this.getTagsHtml('link');
    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

    const customPrintStyle = `
    <style>
    @media print {
      @page {
        size: landscape;
        margin: 1cm;
      }

      body {
        zoom: 0.81;
      }

      table {
        width: 100% !important;
        table-layout: fixed;
        word-wrap: break-word;
      }

      th, td {
        font-size: 12px;
        padding: 4px;
        word-break: break-word;
        text-align: center;
      }

      input, select, button {
        display: none !important;
      }

      .no-print {
        display: none !important;
      }
    }
  </style>
    `;

    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Transaction Details</title>
          ${linksHtml}
          ${stylesHtml}
          ${customPrintStyle}
        </head>
        <body onload="window.print(); window.close()">
          ${printContents}
        </body>
      </html>
    `);
    popupWin.document.close();

    this.isPrintMode = false;
  }, 0);
}















  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join('\r\n');
  }
}



// WEBPACK FOOTER //
// ./src/app/applicant/transaction-details/transaction-details.component.ts